import { useAppDispatch } from "core/utils";
import { useLocation, useParams } from "react-router";

import { ContractPhysicalEditForm } from "src/app/features/Contract/components/forms/ContractPhysicalEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NavigationStateWithReturnTo } from "../../../../core/router/navigation/returnTo";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";
import { setDefaultActiveKey } from "../../../../core/setup/redux/state/tabs/tabState";

export const ContractPhysicalEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.CONTRACTS, "basicTabsWrite");
    const { id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.CONTRACTS}/${id}/${FORM_ACTION.HISTORY}`;

    const dispatch = useAppDispatch();
    const location = useLocation();

    // Only restore the Sites "contracts" tab when we Have come from Site edit page (i.e. this create form was opened from Sites)
    const returnsToSiteEdit = ((location.state as NavigationStateWithReturnTo | null)?.returnTo?.pathname ?? "").startsWith(
        `${BASE_PATH}/${ResourceName.SITES}/${FORM_ACTION.EDIT}/`,
    );
    const setTabsDefaultBeforeBack = () => {
        if (returnsToSiteEdit) dispatch(setDefaultActiveKey("sites_contracts"));
    };

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.contractPhysicalEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} onBeforeNavigate={setTabsDefaultBeforeBack} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton
                        isDisabled={false}
                        url={`${BASE_PATH}/${ResourceName.CONTRACTS}`}
                        onBeforeNavigate={setTabsDefaultBeforeBack}
                    />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <ContractPhysicalEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
